import { css } from "styled-components"

export const BaseStyle = css`
  flex-direction: column;
  align-items: center;
  width: 100%;
`


// WEBPACK FOOTER //
// ./assets/common/components/ProfileCards/common.js